// USER useSwrGetSearchPackPackages ***************************************************************************
// pathname: /v1/search-pack/packages
// ************************************************************************************************
import {
  useSwrApi,
} from 'src/hooks/useSwrApi';


interface SearchPackPackagesProps {
  locale?: string;
  shouldFetch?: boolean;
}


/**
 * @description SWR: fetch available search pack packages.
 * * **locale**: string - the locale to use for the request. Default 'ro'.
 * * **shouldFetch**: boolean - whether to fetch or not.
 */
export const useSwrGetSearchPackPackages = (props?: SearchPackPackagesProps) => {
  // Props destructuring
  const {
    locale = 'ro',
    shouldFetch = true,
  } = props ?? {};


  // SWR: fetch data
  // ********************************************
  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiSchema<'SearchPackageRead'>[]>({
    url: '/v1/search-pack/packages',
    locale,
    shouldFetch,
    apiOptions: {
      revalidateOnMount: true,
      revalidateOnFocus: false,
      dedupingInterval: 60000, // Cache for 1 minute
    },
    toastsOptions: {
      showErrorToast: true,
    },
  });


  // Return data
  // ********************************************
  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};

